/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CustomerTypeDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Retrieve all customer types in the system
 * @summary Get all customer types
 */
export const getAllCustomerTypes = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerTypeDTO[]>(
      {url: `/api/frontend/admin/customer-types`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllCustomerTypesInfiniteQueryKey = () => {
    return [
    'infinite', `/api/frontend/admin/customer-types`
    ] as const;
    }

export const getGetAllCustomerTypesQueryKey = () => {
    return [
    `/api/frontend/admin/customer-types`
    ] as const;
    }

    
export const getGetAllCustomerTypesInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllCustomerTypes>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCustomerTypesInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCustomerTypes>>> = ({ signal }) => getAllCustomerTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllCustomerTypesInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCustomerTypes>>>
export type GetAllCustomerTypesInfiniteQueryError = unknown


export function useGetAllCustomerTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCustomerTypes>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCustomerTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllCustomerTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCustomerTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCustomerTypes>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCustomerTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllCustomerTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCustomerTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCustomerTypes>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all customer types
 */

export function useGetAllCustomerTypesInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllCustomerTypes>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllCustomerTypesInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllCustomerTypesQueryOptions = <TData = Awaited<ReturnType<typeof getAllCustomerTypes>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllCustomerTypesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCustomerTypes>>> = ({ signal }) => getAllCustomerTypes(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllCustomerTypesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCustomerTypes>>>
export type GetAllCustomerTypesQueryError = unknown


export function useGetAllCustomerTypes<TData = Awaited<ReturnType<typeof getAllCustomerTypes>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCustomerTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllCustomerTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCustomerTypes<TData = Awaited<ReturnType<typeof getAllCustomerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllCustomerTypes>>,
          TError,
          Awaited<ReturnType<typeof getAllCustomerTypes>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllCustomerTypes<TData = Awaited<ReturnType<typeof getAllCustomerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all customer types
 */

export function useGetAllCustomerTypes<TData = Awaited<ReturnType<typeof getAllCustomerTypes>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCustomerTypes>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllCustomerTypesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update an existing customer type
 * @summary Update customer type
 */
export const updateCustomerType = (
    customerTypeDTO: CustomerTypeDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<CustomerTypeDTO>(
      {url: `/api/frontend/admin/customer-types`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: customerTypeDTO
    },
      options);
    }
  


export const getUpdateCustomerTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerType>>, TError,{data: CustomerTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateCustomerType>>, TError,{data: CustomerTypeDTO}, TContext> => {

const mutationKey = ['updateCustomerType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateCustomerType>>, {data: CustomerTypeDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateCustomerType(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateCustomerTypeMutationResult = NonNullable<Awaited<ReturnType<typeof updateCustomerType>>>
    export type UpdateCustomerTypeMutationBody = CustomerTypeDTO
    export type UpdateCustomerTypeMutationError = unknown

    /**
 * @summary Update customer type
 */
export const useUpdateCustomerType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateCustomerType>>, TError,{data: CustomerTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateCustomerType>>,
        TError,
        {data: CustomerTypeDTO},
        TContext
      > => {

      const mutationOptions = getUpdateCustomerTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create a new customer type
 * @summary Create customer type
 */
export const createCustomerType = (
    customerTypeDTO: CustomerTypeDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerTypeDTO>(
      {url: `/api/frontend/admin/customer-types`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: customerTypeDTO, signal
    },
      options);
    }
  


export const getCreateCustomerTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerType>>, TError,{data: CustomerTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createCustomerType>>, TError,{data: CustomerTypeDTO}, TContext> => {

const mutationKey = ['createCustomerType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCustomerType>>, {data: CustomerTypeDTO}> = (props) => {
          const {data} = props ?? {};

          return  createCustomerType(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCustomerTypeMutationResult = NonNullable<Awaited<ReturnType<typeof createCustomerType>>>
    export type CreateCustomerTypeMutationBody = CustomerTypeDTO
    export type CreateCustomerTypeMutationError = unknown

    /**
 * @summary Create customer type
 */
export const useCreateCustomerType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCustomerType>>, TError,{data: CustomerTypeDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCustomerType>>,
        TError,
        {data: CustomerTypeDTO},
        TContext
      > => {

      const mutationOptions = getCreateCustomerTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Get a specific customer type by code
 * @summary Get customer type
 */
export const getCustomerType = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<CustomerTypeDTO>(
      {url: `/api/frontend/admin/customer-types/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetCustomerTypeInfiniteQueryKey = (code?: string,) => {
    return [
    'infinite', `/api/frontend/admin/customer-types/${code}`
    ] as const;
    }

export const getGetCustomerTypeQueryKey = (code?: string,) => {
    return [
    `/api/frontend/admin/customer-types/${code}`
    ] as const;
    }

    
export const getGetCustomerTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getCustomerType>>>, TError = unknown>(code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerTypeInfiniteQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerType>>> = ({ signal }) => getCustomerType(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerType>>>
export type GetCustomerTypeInfiniteQueryError = unknown


export function useGetCustomerTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerType>>>, TError = unknown>(
 code: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerType>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerType>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer type
 */

export function useGetCustomerTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getCustomerType>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerTypeInfiniteQueryOptions(code,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetCustomerTypeQueryOptions = <TData = Awaited<ReturnType<typeof getCustomerType>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCustomerTypeQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomerType>>> = ({ signal }) => getCustomerType(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCustomerTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getCustomerType>>>
export type GetCustomerTypeQueryError = unknown


export function useGetCustomerType<TData = Awaited<ReturnType<typeof getCustomerType>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerType<TData = Awaited<ReturnType<typeof getCustomerType>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomerType>>,
          TError,
          Awaited<ReturnType<typeof getCustomerType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCustomerType<TData = Awaited<ReturnType<typeof getCustomerType>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get customer type
 */

export function useGetCustomerType<TData = Awaited<ReturnType<typeof getCustomerType>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCustomerType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCustomerTypeQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete a customer type by code
 * @summary Delete customer type
 */
export const deleteCustomerType = (
    code: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/api/frontend/admin/customer-types/${code}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteCustomerTypeMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerType>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerType>>, TError,{code: string}, TContext> => {

const mutationKey = ['deleteCustomerType'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCustomerType>>, {code: string}> = (props) => {
          const {code} = props ?? {};

          return  deleteCustomerType(code,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCustomerTypeMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCustomerType>>>
    
    export type DeleteCustomerTypeMutationError = unknown

    /**
 * @summary Delete customer type
 */
export const useDeleteCustomerType = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCustomerType>>, TError,{code: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCustomerType>>,
        TError,
        {code: string},
        TContext
      > => {

      const mutationOptions = getDeleteCustomerTypeMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    